import { useEffect } from "react";
import constant from "../constant";
import { hasAuthSession } from "../utils";

const DEFAULT_IDLE_MS = 30 * 60 * 1000;

export function useSessionIdle(timeoutMs = DEFAULT_IDLE_MS) {
  useEffect(() => {
    if (!hasAuthSession()) return undefined;

    let timer;
    const reset = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        window.location.assign(constant.commoncomponent.logout.url);
      }, timeoutMs);
    };

    const events = ["mousedown", "keydown", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, reset, { passive: true }));
    reset();

    return () => {
      clearTimeout(timer);
      events.forEach((event) => window.removeEventListener(event, reset));
    };
  }, [timeoutMs]);
}
